<app-progress
class="engine-progress"
[value]="storyLoadProgress"
[total]="1"></app-progress>